import React, { useState, useEffect } from "react";
import ReactMapGL, { Marker } from "react-map-gl";
import Pin from "assets/Pin";
import locationUtils from "../../../utils/locationutils";
import styles from "./PlacePin.module.scss";
import { getEnvs } from "../../../env";

const initViewport = {
	latitude: 51.78487,
	longitude: -1.28094,
	zoom: 14,
};

type PlacePinProps = {
	close: () => void;
	changeMarkerPosition: (position: {
		latitude: number;
		longitude: number;
	}) => void;
	markerPosition: {
		latitude: number;
		longitude: number;
	};
};

const PlacePin: React.FC<PlacePinProps> = ({
	close,
	changeMarkerPosition,
	markerPosition,
}) => {
	const [viewport, setViewport] = useState({
		latitude: markerPosition.latitude,
		longitude: markerPosition.longitude,
		zoom: 12,
	});
	const [originalMarkerPosition, setOriginalMarkerPosition] = useState();
	const [MAP_BOX_API, setMAP_BOX_API] = useState("");

	useEffect(() => {
		async function setServerUrl() {
			try {
				const envvars: any = await getEnvs();
				setMAP_BOX_API(envvars.REACT_APP_MAP_BOX_API);
			} catch {
				setMAP_BOX_API("");
			}
		}

		setServerUrl();
	}, []);

	useEffect(() => {
		setOriginalMarkerPosition({
			// @ts-ignore
			latitude: markerPosition.latitude,
			longitude: markerPosition.longitude,
		});
	}, []);

	const onMarkerDragEnd = (event: any) => {
		changeMarkerPosition({
			longitude: event.lngLat[0],
			latitude: event.lngLat[1],
		});
	};

	return (
		<>
			<div className={styles.Screen}>
				<div
					className={styles.CloseButton}
					onClick={() => {
						// @ts-ignore
						changeMarkerPosition(originalMarkerPosition);
						close();
					}}
				/>
				{MAP_BOX_API && (
					<ReactMapGL
						mapboxApiAccessToken={MAP_BOX_API}
						{...viewport}
						mapStyle="mapbox://styles/mapbox/streets-v11"
						width="100vw"
						height="100vh"
						onViewportChange={(view: any) => {
							setViewport({ ...view });
						}}
					>
						<Marker
							longitude={markerPosition.longitude}
							latitude={markerPosition.latitude}
							offsetTop={-20}
							offsetLeft={-10}
							draggable
							onDragEnd={onMarkerDragEnd}
						>
							<Pin style={styles.styledPin} />
						</Marker>
					</ReactMapGL>
				)}
				<div className={styles.PlacePinButton} onClick={() => close()}>
					Place Location Pin
				</div>
			</div>
		</>
	);
};

export default PlacePin;
